<div class="loader">
  <img *ngIf="!alternateNameToggle" src="./assets/images/munio-logo.svg" width="89" height="40" class="logo" />
  <img *ngIf="alternateNameToggle" src="{{alternateNameLogoUrl}}" width="89" height="40" class="logo" />
  <svg class="loader-circular" viewBox="25 25 50 50">
    <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"></circle>
  </svg>
</div>
